<template>
  <NTable
    v-if="trades.length"
    :data="trades"
    cell-padding="small"
    :column-splitter="false"
    fixed-header
    :striped="false"
    class="max-h-60"
  >
    <NTableColumn
      v-slot="{ row }"
      :label="t('misc.quantity')"
      prop="quantity"
      sortable
      align="text-right"
    >
      <NumberFormatter #="{ number }" :value="row.quantity">
        <NText variant="overline">
          {{ number }}
        </NText>
      </NumberFormatter>
    </NTableColumn>

    <NTableColumn
      v-slot="{ row }"
      :label="`${t('common.price')} (${t('misc.rial')})`"
      prop="price"
      sortable
      align="text-right"
    >
      <NumberFormatter #="{ number }" :value="row.price" round>
        <NText :key="row.price" dir="ltr" variant="overline">
          {{ number }}
        </NText>
      </NumberFormatter>
    </NTableColumn>

    <NTableColumn
      v-slot="{ row }"
      :label="`${t('misc.value')} (${t('misc.rial')})`"
      prop="value"
      sortable
      align="text-right"
    >
      <NumberFormatter #="{ number }" :value="row.value" round>
        <NText dir="ltr" variant="overline"> {{ number }} </NText>
      </NumberFormatter>
    </NTableColumn>

    <NTableColumn
      v-slot="{ row }"
      :label="t('modules.order.tradeTime')"
      prop="entryDate"
      sortable
      align="text-right"
    >
      <NText :key="row.entryDate" variant="caption1">
        {{ creationTime(row.tradeDateTime) }}
      </NText>
    </NTableColumn>
  </NTable>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TradeItem } from '@libs/api-reference';

import NumberFormatter from '@/components/Number.vue';

defineProps<{
  trades: TradeItem[];
}>();

const { t, d } = useI18n();

const creationTime = (date) =>
  `${d(date, 'shortDate')} ,
    ${d(date, 'shortTime')}`;
</script>
